// @vue/component
export default {
    methods: {
        actionIsVisible(action, selectedRows) {
            return !action.visibleOnColumn || selectedRows.every(row => Boolean(row[action.visibleOnColumn]));
        },
    },
};
